import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';
import HeroSection from './components/HeroSection';
import PopularGrid from './components/PopularGrid';
import CategoryFeature from './components/CategoryFeature';
import ReadingCTA from './components/ReadingCTA';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <>
      <SEOHead
        title="好看韩漫漫画免费漫画 - 韩漫免费漫画在线观看下拉式 - 基德漫画网"
        description="基德漫画网提供好看韩漫漫画免费漫画，支持韩漫免费漫画在线观看下拉式阅读体验。涵盖恋爱、奇幻、动作、悬疑、搞笑、治愈等多种韩漫类型，每日更新海量资源。"
        keywords="好看韩漫,漫画免费漫画,韩漫免费漫画,在线观看下拉式,基德漫画网"
        canonicalUrl="http://bjgjfh.com/"
        schema={[
          {
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '基德漫画网 - 首页',
            description: '基德漫画网提供好看韩漫漫画免费漫画，支持韩漫免费漫画在线观看下拉式阅读体验',
          },
        ]}
      />
      <Navbar />
      <main>
        <HeroSection />
        <PopularGrid />
        <CategoryFeature />
        <ReadingCTA />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}